<div class="input-auto-wrapper" #selectElement
 (click)="clickInput()">
  <input type="text" #autoCompleteInput [placeholder]="placeholder" aria-label="Number" matInput [formControl]="inputControl"
  [matAutocomplete]="auto" class="app-input m-form-control form-control" 
  [ngClass]="[isOpen ? 'remove-border-radius-input' : 'add-border-radius-input', (!isOpen && inputControl.invalid && inputControl.dirty) ? 'app-error-border': '', (inputControl.invalid && submitted) ? 'app-error-border': '' ]"
  (keyup)="onKeyUp($event.target.value)" tabindex="0" [attr.aria-label]="attAriaLabel">
</div>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
    <mat-option *ngFor="let item of  obsrevableArr | async" [value]="item.name">
      {{ item.name }}
    </mat-option>
  </mat-autocomplete>



// WEBPACK FOOTER //
// ./src/app/mat-autocomplete/mat-autocomplete.component.html